export default [
  {
    path: '/admin/trader/test-studio',
    name: 'TestStudio',
    component: () => import('@/views/Admin/Trader/TestStudio/Index.vue'),
    meta: {
      pageTitle: 'Test Studio',
      breadcrumb: [
        { text: 'Trader', active: false },
        { text: 'Test Studio', active: true },
      ],
      resource: 'targets.list',
      action: 'read',
    },
  },
]
